import { TimelinePickResult, TimelineRenderFrame, TimelineRenderItem } from './types';

const HANDLE_HIT_WIDTH_PX = 8;

const containsPoint = (
  x: number,
  y: number,
  item: Pick<TimelineRenderItem, 'x' | 'y' | 'width' | 'height' | 'isPoint'>,
): boolean => {
  if (item.isPoint) {
    const radius = Math.min(item.width, item.height) / 2;
    const cx = item.x + radius;
    const cy = item.y + radius;
    const dx = x - cx;
    const dy = y - cy;
    return (dx * dx + dy * dy) <= radius * radius;
  }
  return x >= item.x
    && x <= item.x + item.width
    && y >= item.y
    && y <= item.y + item.height;
};

const pickPart = (x: number, item: TimelineRenderItem): TimelinePickResult['part'] => {
  if (item.isPoint || !item.canResize || !item.showResizeHandles) {
    return 'body';
  }

  const leftEdgeMax = item.x + Math.min(HANDLE_HIT_WIDTH_PX, item.width / 2);
  const rightEdgeMin = item.x + item.width - Math.min(HANDLE_HIT_WIDTH_PX, item.width / 2);

  if (x <= leftEdgeMax) {
    return 'leftHandle';
  }
  if (x >= rightEdgeMin) {
    return 'rightHandle';
  }
  return 'body';
};

export const pickTimelineItemAtPoint = (
  frame: TimelineRenderFrame,
  localX: number,
  localY: number,
): TimelinePickResult => {
  for (let index = frame.items.length - 1; index >= 0; index -= 1) {
    const item = frame.items[index];
    if (!containsPoint(localX, localY, item)) {
      continue;
    }

    return {
      itemId: item.id,
      part: pickPart(localX, item),
    };
  }

  return {
    itemId: null,
    part: 'none',
  };
};
